import { DateTime } from 'luxon';
import { Plugin } from '../model/plugin';
import { Mod } from '../model/tag';
import { Template } from '../model/template';

export const playlistPlugin: Plugin = {
  tag: 'plugin/playlist',
  name: $localize`⏭️ Playlist`,
  config: {
    name: $localize`⏭️ Playlist`,
    type: 'semantic',
    default: true,
    add: true,
    embeddable: true,
    generated: $localize`Generated by jasper-ui ${DateTime.now().toISO()}`,
    description: $localize`Create a playlist from the list of sources`,
    icons: [{ label: $localize`⏭️`, order: 1 }],
  },
};

export const playlistTemplate: Template = {
  tag: 'plugin/playlist',
  name: $localize`⏭️ Playlist`,
  config: {
    name: $localize`⏭️ Playlist`,
    type: 'semantic',
    generated: 'Generated by jenkins-ui ' + DateTime.now().toISO(),
    view: $localize`♟️`,
    // language=CSS
    css: `
      app-ref-list.plugin_playlist {
        .list-container {
          grid-auto-flow: row dense;
          padding: 4px;
          gap: 8px;
          grid-template-columns:  1fr;
          @media (min-width: 1000px) {
            grid-template-columns:  1fr 1fr;
          }
          @media (min-width: 1500px) {
            grid-template-columns: 1fr 1fr 1fr;
          }
          @media (min-width: 2000px) {
            grid-template-columns: 1fr 1fr 1fr 1fr;
          }
          .list-number {
            display: none;
          }
          .ref {
            break-inside: avoid;
            .toggle {
              display: none;
            }
            @media (max-width: 740px) {
              .actions, .info {
                height: 28px;
              }
            }
          }
        }
      }
    `,
    advancedForm: [{
      key: 'defaultExpanded',
      type: 'boolean',
      defaultValue: true,
      props: {
        label: $localize`Default Expanded:`,
      },
    }],
  },
  defaults: {
    defaultExpanded: true,
    defaultSort: ['modified,DESC'],
    defaultCols: 0, // Leave to CSS screen size detection, but show cols dropdown
  }
};

export const playlistMod: Mod = {
  plugin: [
    playlistPlugin,
  ],
  template: [
    playlistTemplate
  ],
};
